module.exports = __webpack_public_path__ + "assets/projects/berlinfuchs/mobile.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/berlinfuchs/mobile.jpg
// module id = 35
// module chunks = 0